import { fetchReports } from "../clients/reportsClient";
import { Reports } from "../../models/Report";

export const getReports = async (user_id) => {
  const data = await fetchReports(user_id);
  return Reports.fromJson(data);
};
